import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import loadable from "@loadable/component";
import { filterRequiredDocumentList, getDocumentStatuses, getGaEventActionName } from "./selector";
import { NUMBER } from "../../../constants/app-constants";
import disableScroll from "../../../utils/helpers/disable-scroll";
import { sendCustomGaEvents } from "../../../tracking";
import { postInspectionDiyDocUpload } from "../post-inspection-diy/tracking";
import { REQUIRED_DOCUMENTS_LIST } from "../post-inspection-diy/constant";
const RequiredDocumentUpload = loadable(() => import("../required-document-upload"));

// eslint-disable-next-line max-statements
const PostInspectionDiyDocUpload = ({
    postTokenDocuments,
    inspectionResponse,
    diyPaymentApprovalProcessConnect
}) => {
    const {
        documents,
        [REQUIRED_DOCUMENTS_LIST.KYC_DOCUMENTS]: {
            total: totalDocumentCount,
            UPLOAD_PENDING: pendingDocumentCount = NUMBER.ZERO,
            VERIFICATION_FAILED: verificationFailedDocumentCount = NUMBER.ZERO,
            REJECTED: rejectedDocumentCount = NUMBER.ZERO
        } = {}
    } = postTokenDocuments || {};

    const { otherDocuments = {}, isAllOtherDocumentsApproved } = documents || {};
    const { appointmentId, token, isTokenProcessed } = inspectionResponse || {};
    const requiredDocumentList = filterRequiredDocumentList(otherDocuments, REQUIRED_DOCUMENTS_LIST.KYC_DOCUMENTS);
    const isRequiredDocumentsPresent = requiredDocumentList && Object.keys(requiredDocumentList) && !!Object.keys(requiredDocumentList).length;
    const failedDocCount = verificationFailedDocumentCount + rejectedDocumentCount;
    const allDocumentStatus = getDocumentStatuses({totalDocumentCount, pendingDocumentCount, failedDocCount});
    const {
        documentUploadCount,
        isAnyDocPending
    } = allDocumentStatus || {};

    const [showDocList, setShowDocList] = useState(false);

    useEffect(() => {
        disableScroll(showDocList && isAllOtherDocumentsApproved, "hidden");
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showDocList]);

    useEffect(() => {
        if (isTokenProcessed) {
            sendCustomGaEvents({
                ...postInspectionDiyDocUpload,
                eventAction: "Doc Upload token successful",
                eventLabel: appointmentId
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isTokenProcessed]);

    const callDocUploadPageViewGaEvent = () => {
        if (showDocList && !isAllOtherDocumentsApproved) {
            const eventAction = getGaEventActionName({
                isAnyDocPending,
                failedDocCount,
                documentUploadCount
            });

            sendCustomGaEvents({
                ...postInspectionDiyDocUpload,
                eventAction,
                eventLabel: appointmentId
            });
        }
    };

    useEffect(() => {
        if (isRequiredDocumentsPresent) {
            setShowDocList(true);
            if (isAllOtherDocumentsApproved) {
                sendCustomGaEvents({
                    ...postInspectionDiyDocUpload,
                    eventAction: "Doc Upload document success pop-up view",
                    eventLabel: appointmentId
                });
            } else if (isAnyDocPending && failedDocCount) {
                sendCustomGaEvents({
                    ...postInspectionDiyDocUpload,
                    eventAction: "Doc Upload selection of doc verification in failure",
                    eventLabel: appointmentId
                });
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleDiyPaymentApprovalProcess = () => {
        diyPaymentApprovalProcessConnect(token);
    };

    const renderDocs = (isDocUploadAllowed = true, showDocumentProgress = true) => {
        return (
            <RequiredDocumentUpload
                uploadSource={"CUSTOMER"}
                showDocumentProgress={showDocumentProgress}
                isDocUploadAllowed={isDocUploadAllowed}
                appointmentId={appointmentId}
                allDocuments={requiredDocumentList}
                handleDiyPaymentApprovalProcess={handleDiyPaymentApprovalProcess}
                callDocUploadPageViewGaEvent={callDocUploadPageViewGaEvent}
                postTokenDocuments={postTokenDocuments[REQUIRED_DOCUMENTS_LIST.KYC_DOCUMENTS]}
            />
        );
    };

    return (
        <React.Fragment>
            {renderDocs(true, true)}
        </React.Fragment>
    );
};

PostInspectionDiyDocUpload.propTypes = {
    postTokenDocuments: PropTypes.object,
    inspectionResponse: PropTypes.object,
    diyPaymentApprovalProcessConnect: PropTypes.func
};

export default PostInspectionDiyDocUpload;
